module.exports = __webpack_public_path__ + "static/media/Icon.b410c6cc.png";